import React from "react";
import { useLocation } from "react-router-dom";

export const WHATSAPP_NUMBER = "41784040218";
export const WHATSAPP_DISPLAY = "+41 78 404 02 18";
export const waLink = (lang) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    lang === "de"
      ? "Hallo Elite Swiss, ich interessiere mich für eine unverbindliche Beratung."
      : "Hello Elite Swiss, I would like to request a confidential consultation."
  )}`;

export const trackWhatsApp = (page) => {
  if (typeof window.gtag === "function") {
    window.gtag("event", "whatsapp_click", { page });
  }
};

const WhatsAppButton = () => {
  const location = useLocation();
  if (location.pathname.startsWith("/admin")) return null;
  const isDe = location.pathname.startsWith("/muenchen");

  return (
    <a
      href={waLink(isDe ? "de" : "en")}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackWhatsApp(location.pathname)}
      data-testid="whatsapp-floating-button"
      aria-label="WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2.5 bg-[#25D366] text-white pl-4 pr-5 py-3.5 rounded-full shadow-[0_12px_32px_-8px_rgba(37,211,102,0.55)] transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_16px_40px_-8px_rgba(37,211,102,0.65)]"
    >
      <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current" aria-hidden="true">
        <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.816 9.816 0 0 0 12.04 2m.01 1.67c2.2 0 4.26.86 5.82 2.42a8.19 8.19 0 0 1 2.41 5.83c0 4.54-3.7 8.23-8.24 8.23-1.48 0-2.93-.39-4.19-1.15l-.3-.17-3.12.82.83-3.04-.2-.32a8.19 8.19 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.25-8.24M8.53 7.33c-.16 0-.43.06-.66.31-.22.25-.87.86-.87 2.07 0 1.22.89 2.39 1 2.56.14.17 1.76 2.67 4.25 3.73.59.27 1.05.42 1.41.53.59.19 1.13.16 1.56.1.48-.07 1.46-.6 1.67-1.18.21-.58.21-1.07.15-1.18-.07-.1-.23-.16-.48-.27-.25-.14-1.47-.74-1.69-.82-.23-.08-.37-.12-.56.12-.16.25-.64.81-.78.97-.15.17-.29.19-.53.07-.26-.13-1.06-.39-2-1.23-.74-.66-1.23-1.47-1.38-1.72-.12-.24-.01-.39.11-.5.11-.11.27-.29.37-.44.13-.14.17-.25.25-.41.08-.17.04-.31-.02-.44-.06-.11-.56-1.35-.77-1.84-.2-.48-.4-.42-.56-.43-.14 0-.3-.01-.47-.01" />
      </svg>
      <span className="text-xs uppercase tracking-[0.15em] font-medium">
        {isDe ? "WhatsApp" : "WhatsApp"}
      </span>
    </a>
  );
};

export default WhatsAppButton;
